import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { FolderClosed24 } from 'ui/icons';
import { colors, overline, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip/Tooltip';
import { pxToRem } from 'utils/convert';
import { hasHorizontalOverflow } from 'utils/elementHelpers';

export const FolderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  color: ${colors.textSecondary};

  > *:first-child {
    margin: 0 ${spacing.threeEights} 0 ${spacing.quarter};
  }
  &&&:hover {
    color: ${colors.textPrimary};
  }
`;

export const Name = styled.div`
  ${overline}
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;

  width: fit-content;
  max-width: ${pxToRem(242)};
  overflow: hidden;
`;

type Props = {
  name: string;
  hasIcon?: boolean;
};

export const DATA_TEST = {
  container: 'folder-container-breadcrumb',
  icon: 'folder-icon',
};

export const EditorFolderName = ({ name, hasIcon }: Props) => {
  const [showTip, setShowTip] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      const hasOverflow = hasHorizontalOverflow(ref.current);
      if (hasOverflow) {
        setShowTip(hasOverflow);
      }
    }
  }, [name, hasIcon, ref.current, setShowTip]);

  return (
    <FolderContainer data-test={DATA_TEST.container}>
      {hasIcon && <FolderClosed24 data-test={DATA_TEST.icon} />}
      <Tooltip isEnabled={showTip} tooltipContent={name} automaticallyAvoidCollisions>
        <Name ref={ref}>{name}</Name>
      </Tooltip>
    </FolderContainer>
  );
};
